import { makeClient } from '@spree/storefront-api-v2-sdk/dist/client'
window.makeClient = makeClient